// extracted by mini-css-extract-plugin
export default {"SchedulerBody":"SchedulerBody_SchedulerBody__g3Dxt"};